<script lang="ts">
  import Dropdown from "$app/components/Dropdown.svelte"
  import { Palette } from "@untemps/svelte-palette"
  import { Pipette } from "lucide-svelte"

  let props = $props()
  let response = props.response
  let count = props.count
  const colors = [
    "#b2e4ed",
    "#f4ecdb",
    "#ffe5f7",
    "#eddefd",
    "#e8f4e5",
    "#EC790E",
    "#77CBDA",
    "#F2BAB3",
    "#FEC89A",
    "#FCEFB4"
  ]

  let bgColor = $state("#f9fafb")
  let openPalette = $state(false)
</script>

<div class="border border-gray-200 min-w-42">
  <div class="text-center py-1 px-2 border-b border-gray-100 relative">
    Response #{count + 1}
    <div class="absolute top-1 right-1">
      <Dropdown bind:open={openPalette}>
        {#snippet button()}
          <button
            class="focus:outline-none text-blue-400 mr-1 border border-blue-200 p-0.5 bg-blue-100 rounded"
            title="Pick Color"
          >
            <Pipette class="w-4 h-4 text-indigo-700" />
          </button>
        {/snippet}
        <div>
          <div
            class="origin-top-right absolute -left-48 mt-2 w-96 lg:w-120 bg-white focus:outline-none z-10"
          >
            <Palette
              {colors}
              on:select={({ detail: { color } }) => {
                bgColor = color
                openPalette = false
              }}
            />
          </div>
        </div>
      </Dropdown>
    </div>
  </div>
  <div class="text-center py-1 px-2" style="background-color: {bgColor}">
    {#if response == "undefined" || response == "" || response == "null"}
      <span class="p-2 text-gray-600 text-sm italic">N/A</span>
    {:else}
      <span class="p-2">{response}</span>
    {/if}
  </div>
</div>
